import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import type {StageProfile} from '../forecast-app/shared/util/projectStageUtil';
import {UpdateProjectStageMutation, UpdateProjectStageMutation$data} from './__generated__/UpdateProjectStageMutation.graphql';

type UpdateProjectStageInput = {
	id: string;
	name: string;
	profile: StageProfile;
	/** Sent only after the admin accepted the warning that the stage is the last with its current profile. */
	allowLastWithProfile?: boolean;
};

const mutation = graphql`
	mutation UpdateProjectStageMutation($input: UpdateProjectStageInput!) {
		updateProjectStage(input: $input) {
			projectStage {
				id
				name
				profile
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateProjectStageInput,
	onSuccess?: (response: UpdateProjectStageMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<UpdateProjectStageMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				id: input.id,
				name: input.name,
				profile: input.profile,
				// Left out unless the admin accepted the warning; the backend refuses the change without it.
				...(input.allowLastWithProfile ? {allowLastWithProfile: true} : {}),
			},
		},
		configs: [],
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
